import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  NgZone,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { LoaderService } from './services/loader/loader.service'
import { ToastrService } from 'ngx-toastr'
import { ActivatedRoute, Router } from '@angular/router'
import { CommonService } from './services/common/common.service'
import { AppInitService } from './services/app-init/app-init.service'
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { MatSidenav } from '@angular/material/sidenav'
import { SidenavService } from './services/sidenav.service'
import { NgxSpinnerService } from 'ngx-spinner'
import { STRINGS } from './shared-components/constants'
declare let pendo: any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches))
  @ViewChild('panel', { static: true }) private sidePanel: MatSidenav
  @ViewChild('content', { static: true, read: ViewContainerRef })
  private vcf: ViewContainerRef
  title = 'inmar-app'
  private subscription: Subscription
  isLogin: any
  isExportLoader: any
  public pathInfo
  constructor(
    private loader: LoaderService,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private commonserv: CommonService,
    private appInit: AppInitService,
    private breakpointObserver: BreakpointObserver,
    private sidenavService: SidenavService,
    private cdr: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private ngZone: NgZone
  ) {
    this.subscription = this.loader.loaderState.subscribe((val) => {
      if (this.isExportLoader === false) {
        this.spinner.hide()
      } else {
        if (val == true) {
          this.spinner.show()
        } else {
          this.spinner.hide()
        }
      }
    })

    this.loader.showExportLoader.subscribe((response) => {
      if (response === false) {
        this.isExportLoader = false
      }
    })
    this.appInit.Envronment$.subscribe((res) => {
      // Use platformLocation properties or fallback to window.location.origin
      const currentURL = this.appInit.platformLocation?.protocol
        ? `${this.appInit.platformLocation.protocol}//${this.appInit.platformLocation.hostname}${this.appInit.platformLocation.port ? ':' + this.appInit.platformLocation.port : ''}`
        : window.location.origin
      // res.api.url = 'https://fintech-dmp-test-api-service-822157821.us-central1.run.app/';

      // if (currentURL === this.appInit.URLS.TEST_UI || currentURL === this.appInit.URLS.LOCALHOST) {
      if (currentURL === this.appInit.URLS.TEST_UI) {
        res.api.url = this.appInit.URLS.TEST_API + '/'
      }
      localStorage.setItem('baseUrl', JSON.stringify(res))
    })
  }

  ngOnInit() {
    this.sidenavService.setPanel(this.sidePanel)
    this.sidenavService.setContentVcf(this.vcf)
    this.isLogin = sessionStorage.getItem('isLogin')
    window.onbeforeunload = function () {
      return 'Your work will be lost.'
    }

    if (sessionStorage.getItem('api_token')) {
      this.allFunction()
    }

    this.loader.userInfo.subscribe((res: any) => {
      if (!res || !res.user_name || !res.tenant_id) return

      const hostname = window.location.hostname
      const envPrefix =
        hostname === 'localhost'
          ? 'local_'
          : hostname.includes('beta')
            ? 'qa_'
            : hostname.includes('uat')
              ? 'uat_'
              : hostname.includes('dev')
                ? 'dev_'
                : ''

      const visitorId = `${envPrefix}${res.user_name.trim().toLowerCase()}`

      const payload = {
        visitor: {
          id: visitorId,
          full_name: `${res.first_name ?? ''} ${res.last_name ?? ''}`.trim(),
          user_type: res.user_type,
          tenant: res.tenant_name,
          user_name: res.user_name,
          email: res?.email,
        },
        account: {
          id: String(res.tenant_id),
          name: res.tenant_name,
        },
      }

      const currentVisitor = window['_lastPendoVisitor']

      if (currentVisitor !== visitorId) {
        if (!window['_pendoInitialized']) {
          pendo.initialize(payload)
          window['_pendoInitialized'] = true
        } else {
          pendo.identify(payload)
        }

        window['_lastPendoVisitor'] = visitorId
      }

      this.handleUserNavigation(res)
    })
  }

  private handleUserNavigation(userInfo: any): void {
    // Don't navigate if user_type is missing
    if (!userInfo.user_type) {
      return
    }

    // Don't navigate if already logged in (unless this is a fresh tenant switch)
    if (this.isLogin) {
      return
    }

    // Prepare user data for storage
    const setUserData = () => {
      if (userInfo.user_type !== 1) {
        if (
          (userInfo.is_approver_level_1 === true &&
            userInfo.multi_level_approval === true) ||
          userInfo.multi_level_approval === false
        ) {
          localStorage.setItem(
            'user',
            `${userInfo.first_name} ${userInfo.last_name}`
          )
          localStorage.setItem('user_id', userInfo.user_id)
        }
      } else {
        localStorage.setItem('user', '')
      }
    }

    // Navigate based on user type
    const navigateUser = () => {
      if (userInfo.user_type === 1) {
        return this.router.navigateByUrl('/manage-deductions/new-remittance')
      } else {
        return this.router.navigateByUrl('/manage-deductions/approvals')
      }
    }

    this.ngZone.run(() => {
      setUserData()
      Promise.resolve().then(() => {
        navigateUser()
          .then(() => {
            sessionStorage.setItem(
              'isLogin',
              STRINGS.SESSION_STORAGE_IS_LOGIN_KEY
            )
            this.cdr.detectChanges()
          })
          .catch((err) => {
            console.error('Navigation error:', err)
            sessionStorage.setItem(
              'isLogin',
              STRINGS.SESSION_STORAGE_IS_LOGIN_KEY
            )
          })
      })
    })
  }

  allFunction() {
    this.getUserInfo()
    this.userList()
  }

  userList() {
    this.commonserv.searchUser('').subscribe((res: any) => {
      this.loader.userList.next(res.users_data)
    })
  }

  /**
   * Decodes the JWT api_token and extracts tenant_id from its payload.
   * This allows setting x-tenant-id header on the very first getUserInfo call,
   * avoiding a second API round-trip just to fetch tenant-specific data (e.g. logo).
   *
   * JWT payloads are base64url-encoded (uses - and _ instead of + and /, no padding).
   * atob() requires standard base64, so we normalise the segment first:
   *   1. Guard that the token has exactly 3 dot-separated segments
   *   2. Replace - → + and _ → / (base64url → base64 character set)
   *   3. Pad to a multiple of 4 with = characters
   */
  private extractTenantIdFromToken(): void {
    if (sessionStorage.getItem('tenant_id')) return
    const token = sessionStorage.getItem('api_token')
    if (!token) return
    try {
      const segments = token.split('.')
      if (segments.length !== 3) return
      // Normalise base64url → standard base64 before decoding
      const base64 = segments[1]
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(Math.ceil(segments[1].length / 4) * 4, '=')
      const payload = JSON.parse(atob(base64))
      if (payload?.tenant_id) {
        sessionStorage.setItem('tenant_id', String(payload.tenant_id))
      }
    } catch {
      // Malformed token — tenant_id will be set from API response instead
    }
  }

  async getUserInfo() {
    // Set tenant_id from JWT before the API call so the header is included on the first request
    this.extractTenantIdFromToken()

    const res: any = await this.commonserv.getUserInfo().toPromise()
    // Persist tenant_id if it wasn't already available from the token
    if (res?.tenant_id && !sessionStorage.getItem('tenant_id')) {
      sessionStorage.setItem('tenant_id', String(res.tenant_id))
    }
    this.loader.userInfo.next(res)
  }

  transformData(data: any) {
    const transformArray = (arr: string[]) =>
      arr.map((item) => ({ id: item, name: item }))
    return {
      spend_type: transformArray(data.spend_type),
      brand: transformArray(data.brand),
      product_group: transformArray(data.product_group),
      product_category: transformArray(data.product_category),
      promotion_status: transformArray(data.promotion_status),
    }
  }
}
